import { PageHeader } from '@shared/components';

import { useExamCenter } from '../../providers';
import { ExamCenterDetailsNavigationTabs } from '../exam-center-details-navigation-tabs';

export default function ExamCenterDetailsPageHeader() {
  const { examCenter } = useExamCenter();
  const { nameTH, code } = examCenter;

  return <PageHeader title={`${code}: ${nameTH}`} tabs={<ExamCenterDetailsNavigationTabs />} />;
}
